import { FormGetter, FormInput, FormTab } from '@kirz/mui-admin';
import React from 'react';

export default function LegalDocumentsTab(props: { clientId: number }) {
  return (
    <FormGetter
      names={['type']}
      render={(x) => {
        const required = x.type === 'legal';

        return (
          <>
            <FormTab tab="legal-documents">
              <FormInput
                name="inn"
                label="ИНН"
                sm={6}
                md={4}
                required={required}
              />
              <FormInput
                name="legalKpp"
                label="КПП"
                sm={6}
                md={4}
                required={required}
              />
              <FormInput
                name="legalOgrn"
                label="ОГРН"
                sm={6}
                md={4}
                required={required}
              />
              <FormInput
                name="legalAddress"
                label="Юридический адрес"
                sm={12}
                md={6}
                required={required}
              />
              <FormInput
                name="legalActualAddress"
                label="Фактический адрес"
                sm={12}
                md={6}
                required={required}
              />
              <FormInput
                name="legalCurrentAccount"
                label="Расчетный счёт"
                md={6}
              />
              <FormInput
                name="legalCorrespondentAccount"
                label="Корреспондентский счёт"
                md={6}
                required={required}
              />
              <FormInput
                name="legalCeoFullname"
                label="ФИО генерального директора"
                md={12}
                required={required}
              />
            </FormTab>
          </>
        );
      }}
    />
  );
}
